import { configService } from "../index";
import Experience from "../../models/experience";
import { BaseRequests } from "./BaseRequestsV2";
import { BaseRequestsInterface } from "./BaseRequestsV2";
// import { BaseRequests } from "./BaseRequests";
// import { BaseRequestsInterface } from "./BaseRequests";

export default {
  ...BaseRequests(
    () => configService.newexperiences,
    "experience",
    () => new Experience()
  )
} as BaseRequestsInterface;
